import { ReactNode, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { SCHEDULE_TEMPLATE_SEARCH_PARAM } from "@components/invoices/views/scheduleColumnHandoff";
import { BillScheduleWiring } from "./billScheduleColumns";
import { useBillScheduleCallbacks } from "./useBillScheduleCallbacks";

/**
 * The bills page's Schedule column wiring: undefined while the flags are off,
 * and carrying the policy a "Add bills" deep link arrived with.
 */
export function useBillScheduleWiring(
    isEnabled: boolean,
    refresh?: { onRefreshed?: () => void },
): {
    scheduleWiring: BillScheduleWiring | undefined;
    scheduleOverlays: ReactNode;
} {
    const [searchParams] = useSearchParams();
    const prioritizedScheduleTemplateId =
        searchParams.get(SCHEDULE_TEMPLATE_SEARCH_PARAM) ?? undefined;
    const { scheduleCallbacks, scheduleOverlays } =
        useBillScheduleCallbacks(refresh);

    const scheduleWiring = useMemo(
        () =>
            isEnabled
                ? {
                      callbacks: scheduleCallbacks,
                      prioritizedScheduleTemplateId,
                  }
                : undefined,
        [isEnabled, scheduleCallbacks, prioritizedScheduleTemplateId],
    );

    return {
        scheduleWiring,
        scheduleOverlays: isEnabled ? scheduleOverlays : null,
    };
}
